import { defineMessages } from 'react-intl';

export default defineMessages({
  infoModalBody: {
    id: 'login_signup_v2.modal',
    defaultMessage: 'You can change all your account settings at any time in user settings',
  },
});
